import styled from 'styled-components';

import Slider from './Slider';

const EventVideoModalMobileSlider = styled(Slider)`
  .slick-dots {
    bottom: -25px;
    li {
      button {
        background-color: #ced1d8;
      }
      &.slick-active button {
        background-color: #2294df;
      }
    }
  }
`;

export default EventVideoModalMobileSlider;
